import { Box, Paper } from "@mui/material";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import Flex from "../../../../components/Flex";
import { useGetSuperBill } from "../../../../queries/billings/use-get-super-bill";
import { useGetPatient } from "../../../../queries/use-get-patient-uuid";
import { getXtenantId } from "../../../../utils/utils";
import { useRenderingProviderInfo } from "./use-rendering-provider-info";
import PatientDetailsSideSection from "./PatientDetailsSideSection";
import SuperBillHeader from "./SuperBillHeader";
import AddSuperBill from "./UpsertSuperBill";
import ReadOnlyFields from "../../../../components/ReadOnlyFields";
import { INVOICE_VIEW_TITLE, PR_INVOICE_VIEW_TITLE } from "./billing-constant";

const ViewSuperBillingLayout = () => {
  const { patientId, superBillId } = useParams();

  const patientValidationFormik = useFormik({
    initialValues: {
      patient: patientId || undefined,
    },
    validationSchema: Yup.object({
      patient: Yup.string().required().label("Patient"),
    }),
    enableReinitialize: true,
    onSubmit: () => {},
  });
  const { data: patientData } = useGetPatient(
    patientValidationFormik?.values?.patient
  );
  const { data: patientDataBillDetails } = useGetSuperBill({
    superBillUuid: superBillId ?? "",
    xTENANTID: getXtenantId(),
  });

  const isPatientResponsibilityInvoice =
    patientDataBillDetails?.data?.patientResponsibilityInvoice === true;

  // Show Rendering Provider Details (NPI / License TX from the provider
  // record), matching the Invoice Report.
  const renderingProviderInfo = useRenderingProviderInfo(
    patientDataBillDetails?.data
  );

  return (
    <ReadOnlyFields>
      <Flex height={"calc(100vh - 4.4rem)"} p={1.8} gap={2}>
        <Flex
          flexDirection={"column"}
          width={"80%"}
          gap={2}
          minHeight={"calc(100vh - 60px)"}
        >
          <Paper
            sx={{
              height: "auto",
              p: 1.2,
              boxSizing: "border-box",
              overflow: "clip",
            }}
            elevation={5}
          >
            <SuperBillHeader
              patientsData={patientData}
              patientValidationFormik={patientValidationFormik}
              viewBill={false}
              title={
                isPatientResponsibilityInvoice
                  ? PR_INVOICE_VIEW_TITLE
                  : INVOICE_VIEW_TITLE
              }
            />
          </Paper>
          <Paper
            sx={{
              height: "auto",
              p: 1.2,
              boxSizing: "border-box",
              overflow: "auto",
            }}
            elevation={5}
          >
            <AddSuperBill
              patientsData={patientData}
              patientDataBillDetails={patientDataBillDetails?.data}
              viewBill={false}
              superBillId={superBillId}
              isPatientResponsibilityInvoice={isPatientResponsibilityInvoice}
            />
          </Paper>
        </Flex>
        <Box width={"20%"} height="inherit">
          <Paper
            sx={{
              height: "inherit",
              p: 1.2,
              boxSizing: "border-box",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
            }}
            elevation={5}
          >
            <PatientDetailsSideSection
              patientsData={patientData}
              viewBill={false}
              renderingProviderInfo={renderingProviderInfo}
            />
          </Paper>
        </Box>
      </Flex>
    </ReadOnlyFields>
  );
};

export default ViewSuperBillingLayout;
